import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { languages } from '../../../../../../configs/language'
import { selectUserProfile } from '../../../../../common/category/store/slice'
import { Element } from '../../../../../common/html/element'
import { Input } from '../../../../../common/html/input'
import { InputTextArea } from '../../../../../common/html/input/InputTextArea'
import { PopupAction } from '../../../../../common/popup/PopupAction'
import EventEmitter, {
  SHOW_POPUP_CONFIRMATION,
} from '../../../../../helpers/EventEmitter'
import { getOrderRequest } from '../../store/thunk'
import { POPUP_FIELD_KEY } from './constants'
import classes from './index.module.scss'

const { NAME, REPORT_TYPE, NOTE, REGISTRATION_NUMBER, PHONE, EMAIL } =
  POPUP_FIELD_KEY

export const PopupCreateRequest = ({
  isOpen,
  onClose,
  company,
  currentReport,
}) => {
  const dispatch = useDispatch()

  const userProfile = useSelector(selectUserProfile)
  const locale = useSelector((state) => state.i18n.locale)

  const [form, setForm] = useState({})

  useEffect(() => {
    setForm({
      [NAME]: company.companyName || '',
      [REPORT_TYPE]: currentReport.name || '',
      [NOTE]: '',
      [REGISTRATION_NUMBER]: company.registrationNumber || '',
      [EMAIL]: userProfile.companyEmail || '',
      [PHONE]: userProfile.companyPhone || '',
    })
  }, [currentReport])

  const onSubmit = () => {
    const params = {
      Sku: currentReport.sku,
      ReportName: currentReport.name,
      CountryCode: currentReport.countryCode,
      CompanyId: company?.companyId,
      CompanyName: company?.companyName,
      Note: form[NOTE],
      Type: 'Bussiness',
      PhoneNumber: form[PHONE],
      Email: form[EMAIL],
      RegisterNumber: company?.registrationNumber,
    }
    dispatch(getOrderRequest(params))
      .unwrap()
      .then(() => {
        EventEmitter.dispatch(
          SHOW_POPUP_CONFIRMATION,
          'internationalPreview.CONFIRM_MESSAGE',
        )
      })
      .catch(() => {})
    onClose()
  }

  const onChange = (key, event) => {
    const eventValue = event.target.value

    if (key === NOTE) {
      setForm({ ...form, [key]: eventValue })
    }
  }

  return (
    <>
      <PopupAction
        title="internationalPreview.CREATE_REQUEST"
        isShow={isOpen}
        handleClose={onClose}
        btnSubmit={{
          label: 'internationalPreview.SUBMIT',
          event: onSubmit,
          isI18n: true,
          style: { fontSize: 12 },
        }}
        btnCancel={{
          label: 'internationalPreview.CANCEL',
          event: onClose,
          isI18n: true,
          style: { fontSize: 12 },
        }}
      >
        <Element
          style={{ fontSize: 12 }}
          className={['pt1', classes.popupCheckData].join(' ')}
        >
          <div className={classes.elementEach}>
            <Input
              disabled
              isShowLabel
              isShowIcon={false}
              placeHolder="internationalPreview.COMPANY_NAME"
              value={form[NAME]}
              style={{ color: '#9C9C9C' }}
              styleLabel={{ color: '#3A414B' }}
            />
          </div>
          <div className={classes.elementEach}>
            <Input
              disabled
              isShowLabel
              isShowIcon={false}
              placeHolder="internationalPreview.REGISTRATION_NUMBER"
              value={form[REGISTRATION_NUMBER]}
              style={{ color: '#9C9C9C' }}
              styleLabel={{ color: '#3A414B' }}
            />
          </div>
          <div className={classes.elementEach}>
            <Input
              disabled
              isShowLabel
              isShowIcon={false}
              placeHolder="internationalPreview.REPORT_TYPE"
              value={form[REPORT_TYPE]}
              style={{ color: '#9C9C9C' }}
              styleLabel={{ color: '#3A414B' }}
            />
          </div>
          <div className={classes.elementEach}>
            <Input
              disabled
              isShowLabel
              isShowIcon={false}
              placeHolder="businessConciergeService.EMAIL_ADDRESS"
              value={form[EMAIL]}
              style={{ color: '#9C9C9C' }}
              styleLabel={{ color: '#3A414B' }}
            />
          </div>
          <div>
            <Input
              disabled
              isShowLabel
              isShowIcon={false}
              placeHolder="businessConciergeService.PHONE_NUMBER"
              value={form[PHONE]}
              style={{
                color: '#9C9C9C',
                marginBottom: locale === languages.en ? 12 : 24,
              }}
              styleLabel={{ color: '#3A414B' }}
            />
          </div>
          <div className={classes.elementEach}>
            <InputTextArea
              isShowLabel
              placeHolder="internationalPreview.LEAVE_US_MESSAGE"
              rows={8}
              onChange={(e) => onChange(POPUP_FIELD_KEY.NOTE, e)}
              style={{
                resize: 'none',
                marginTop: locale === languages.en ? 16 : 0,
              }}
            />
          </div>
        </Element>
      </PopupAction>
    </>
  )
}
